/**
 * /dashboard/hiring/jobs — Hiring jobs (requisitions list).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/hiring/jobs/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { RequisitionsTab } from "@/components/hiring/requisitions-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/jobs",
)({
  component: HiringJobsRoute,
});

function HiringJobsRoute() {
  return (
    <HiringModuleShell
      title="Jobs"
      description="Open job requisitions in your organisation."
    >
      <HiringFeatureGate>
        <RequisitionsTab />
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
